import ModalAccessibility from "../utilities/modalAccessibility";
class ShareTheLoveEvent {
    constructor() {
        this.addModalEvents();
    }
    addModalEvents() {
        const disclaimerModal = document.getElementById("shareTheLoveDisclaimerModal");
        disclaimerModal.addEventListener("keydown", (e) => {
            ModalAccessibility.handleModalTabbing(disclaimerModal, "", e);
        });
        const faqModal = document.getElementById("shareTheLoveFaqModal");
        faqModal.addEventListener("keydown", (e) => {
            ModalAccessibility.handleModalTabbing(faqModal, "", e);
        });
    }
}
window.DoUtility.SelfInstantiateOnLoad(ShareTheLoveEvent);
